/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { StandardProps } from '@/newcar/ui/contract';
import { Show } from '@/newcar/ui/molecule';
import { ConvertType } from '@/newcar/ui/contract/config';
import * as styles from './index.module.styl';

interface TextFieldProps extends StandardProps {
  /**
   * @required
   * @type {string}
   * @memberof TextFieldProps
   */
  id: string;

  /**
   * @required
   * @type {string}
   * @memberof TextFieldProps
   */
  type: string;

  /**
   * @required
   * @type {string}
   * @memberof TextFieldProps
   */
  label: string;

  /**
   * @required
   * @type {string | number}
   * @memberof TextFieldProps
   */
  value: string | number;

  /**
   * @default {false}
   * @type {boolean}
   * @memberof TextFieldProps
   */
  readonly?: boolean;

  /**
   * @default {false}
   * @type {boolean}
   * @memberof TextFieldProps
   */
  optional?: boolean;

  /**
   * @default {}
   * @type {object}
   * @memberof TextFieldProps
   */
  limit?: {};

  /**
   * @default {''}
   * @type {string}
   * @memberof TextFieldProps
   */
  placeholder?: string;

  /**
   * @default {''}
   * @type {string}
   * @memberof TextFieldProps
   */
  forwardHelperText1?: string;

  /**
   * @default {''}
   * @type {string}
   * @memberof TextFieldProps
   */
  forwardHelperText2?: string;

  /**
   * @default {''}
   * @type {string}
   * @memberof TextFieldProps
   */
  helperText?: string;

  /**
   * @default {''}
   * @type {string}
   * @memberof TextFieldProps
   */
  tooltip?: string;

  /**
   * @default {''}
   * @type {string}
   * @memberof TextFieldProps
   */
  adornmentStart?: string;

  /**
   * @default {''}
   * @type {string}
   * @memberof TextFieldProps
   */
  adornmentStartClass?: string;

  /**
   * @default {''}
   * @type {string}
   * @memberof TextFieldProps
   */
  adornmentEnd?: string;

  /**
   * @default {''}
   * @type {string}
   * @memberof TextFieldProps
   */
  errorMessage?: string;

  /**
   * @default {null}
   * @type {ConvertType}
   * @memberof TextFieldProps
   */
  convert?: ConvertType;

  /**
   * @required
   * @type {(event: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>}
   * @memberof TextFieldProps
   */
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void | Promise<void>;

  /**
   * @required
   * @type {(event: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>}
   * @memberof TextFieldProps
   */
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>;

  /**
   * @required
   * @type {(event: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>}
   * @memberof TextFieldProps
   */
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void | Promise<void>;

  /**
   * @default {null}
   * @type {(event: React.MouseEvent<HTMLAnchorElement>) => void | Promise<void>}
   * @memberof TextFieldProps
   */
  onClearField?: (event: React.MouseEvent<HTMLAnchorElement>) => void | Promise<void>;
}

export default function TextField(props: TextFieldProps): JSX.Element {
  const {
    id,
    type,
    label,
    value,
    readonly = false,
    optional = false,
    limit = {},
    className = '',
    placeholder = '',
    forwardHelperText1 = '',
    forwardHelperText2 = '',
    helperText = '',
    tooltip = '',
    adornmentStart = '',
    adornmentStartClass = 'is-full',
    adornmentEnd = '',
    errorMessage = '',
    convert,
    onFocus,
    onChange,
    onBlur,
    onClearField,
  } = props;

  // UseEffects
  useEffect(() => {
    const element = document.getElementById(id) as HTMLInputElement;
    element.value = value as string;
  }, []);

  // Functions
  const handleInputBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    if (convert) {
      const element = document.getElementById(id) as HTMLInputElement;
      element.value = convert.function(value as string, convert.targets);
      onChange(event);
    }
    onBlur(event);
  };

  // Classes
  let isValiedClass = '';
  if (value && !errorMessage) {
    isValiedClass = styles.isValied;
  }

  function isErrDisplay(): 'true' | 'false' | undefined {
    if (errorMessage !== '') {
      return 'true';
    }
    if (errorMessage === '' && value === '') {
      return undefined;
    }
    if (errorMessage === '' && value !== '') {
      return 'false';
    }
    return undefined;
  }

  return (
    <>
      <Show when={Boolean(label)}>
        <div className={`columns is-vcentered is-mobile ${forwardHelperText1 || forwardHelperText2 ? '' : 'is-margin-bottom-3'}`}>
          <Show when={optional}>
            <div className={`column is-narrow has-text-weight-bold is-flex ${styles.optionalIcon}`}>任意</div>
          </Show>
          <div className="column is-narrow">{label}</div>
        </div>
      </Show>
      <Show when={forwardHelperText1 !== ''}>
        <p className={`is-size-6 ${forwardHelperText2 ? '' : 'is-margin-bottom-2'}`}>
          {forwardHelperText1}
        </p>
      </Show>
      <Show when={forwardHelperText2 !== ''}>
        <p className="is-size-6 is-margin-bottom-2">
          {forwardHelperText2}
        </p>
      </Show>
      <div className={className}>
        <div
          className={`columns is-vcentered is-mobile is-multiline ${styles.cInput}`}
          aria-invalid={isErrDisplay()}
        >
          <Show when={adornmentStart !== ''}>
            <div className={`column is-narrow has-text-center ${adornmentStartClass}`}>
              <p tabIndex={-1}>{adornmentStart}</p>
            </div>
          </Show>
          <div className={`column is-relative ${isValiedClass}`}>
            <input
              id={id}
              name={id}
              {...limit}
              data-gtm={`gtm-newcarform-${id}`}
              className={`${styles.cInputField} is-size-4`}
              placeholder={placeholder}
              readOnly={readonly}
              type={type}
              onChange={onChange}
              onBlur={handleInputBlur}
              onFocus={onFocus}
            />
            <Show when={!readonly}>
              <a
                id={`${id}_clear`}
                onMouseDown={onClearField}
                className={styles.cInputClear}
                tabIndex={-1}
              />
            </Show>
            <Show when={tooltip !== ''}>
              <div className={`${styles.cInput__tooltip} is-size-6`}>
                {tooltip}
              </div>
            </Show>
            <Show when={errorMessage !== ''}>
              <div className={`${styles.cInputError} is-size-6`}>
                {errorMessage}
              </div>
            </Show>
          </div>
          <Show when={adornmentEnd !== ''}>
            <div className="column is-narrow has-text-center is-padding-left-3">
              <p tabIndex={-1}>{adornmentEnd}</p>
            </div>
          </Show>
        </div>
      </div>
      <Show when={helperText !== ''}>
        <p className="is-size-6 is-margin-top-1">
          {helperText}
        </p>
      </Show>
    </>
  );
}
